import React from 'react';
import { Box, Container, Grid, Typography, Paper } from '@mui/material';
import { Reveal, HOME_COLORS, sectionLabelSx } from './common';

const AVATAR_GRADIENTS = [
  [HOME_COLORS.dark, HOME_COLORS.teal],
  [HOME_COLORS.sky, HOME_COLORS.skyLight],
  [HOME_COLORS.mid, HOME_COLORS.sky],
  ['#6a1b9a', '#ab47bc'],
  ['#ef6c00', '#ffb300'],
  [HOME_COLORS.deep, HOME_COLORS.mid],
];

const initialsOf = (name) => name.split(' ').filter(Boolean).map((p) => p[0]).slice(0, 2).join('').toUpperCase();

export default function LeadershipSection({ people }) {
  if (!people || people.length === 0) return null;

  return (
    <Box id="leadership" sx={{ py: { xs: 8, md: 12 }, bgcolor: '#fff', scrollMarginTop: '80px' }}>
      <Container maxWidth="lg">
        <Reveal>
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography sx={sectionLabelSx}>Leadership</Typography>
            <Typography variant="h3" sx={{ fontWeight: 800, color: HOME_COLORS.dark, fontSize: { xs: '2rem', md: '2.6rem' } }}>
              Guided by experienced educators
            </Typography>
            <Typography sx={{ color: '#657875', maxWidth: 620, mx: 'auto', mt: 1.5 }}>
              Meet the principal and senior faculty leading academics and clinical training at our college.
            </Typography>
          </Box>
        </Reveal>

        <Grid container spacing={3}>
          {people.map((p, idx) => {
            const [c1, c2] = AVATAR_GRADIENTS[idx % AVATAR_GRADIENTS.length];
            return (
              <Grid item xs={12} sm={6} md={4} key={p.name}>
                <Reveal delay={idx * 80}>
                  <Paper
                    elevation={0}
                    sx={{
                      p: 3.5, borderRadius: 4, textAlign: 'center', border: '1px solid #dcebe7', height: '100%',
                      transition: 'transform 0.35s ease, box-shadow 0.35s ease',
                      '&:hover': { transform: 'translateY(-8px)', boxShadow: '0 20px 40px rgba(0,77,64,0.14)' },
                      '&:hover .avatar-ring': { transform: 'scale(1.06)' },
                    }}
                  >
                    <Box
                      className="avatar-ring"
                      sx={{
                        width: 88, height: 88, borderRadius: '50%', mx: 'auto', mb: 2,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        background: `linear-gradient(135deg, ${c1}, ${c2})`,
                        color: '#fff', fontWeight: 800, fontSize: '1.6rem',
                        boxShadow: `0 10px 24px ${c1}55`,
                        transition: 'transform 0.35s ease',
                      }}
                    >
                      {initialsOf(p.name)}
                    </Box>
                    <Typography sx={{ fontWeight: 800, color: HOME_COLORS.dark, fontSize: '1.05rem' }}>{p.name}</Typography>
                    <Typography variant="body2" sx={{ color: HOME_COLORS.mid, fontWeight: 700, mb: 0.5 }}>{p.designation}</Typography>
                    {p.specialization && (
                      <Typography variant="caption" sx={{ color: '#8a9a97' }}>{p.specialization}</Typography>
                    )}
                  </Paper>
                </Reveal>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </Box>
  );
}
